import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalService } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-mensaje-firma-electronica-invalida',
  standalone: true,
  imports: [DialogModule, TranslateModule, ButtonModule],
  styleUrl: './mensaje-firma-electronica-invalida.component.scss',
  template: `
  <p-dialog closable="true" [(visible)]="visible" (onHide)="onHide()" [draggable]="false"
    [breakpoints]="{'2000px': '630px', '1900px': '630px', '1700px': '630px',
      '1400px': '630px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}"
    [modal]="true" [styleClass]="'alert'" [resizable]="false">
    <ng-template pTemplate="header">
      <header>
      </header>
    </ng-template>
    <main class="container-modal-message">
      <div class="grid flex-column sm:flex-row">
        <section class="col flex flex-column align-items-center item-message p-3">
          <div>
            <div class="flex justify-content-center align-items-center">
              <img src="assets/img/icon/firma.png" alt="Firma Electrónica" class="firma-image">
            </div>
            <h2 class="  text-center text-blue-general font-18 mb-2 font-medium text-uppercase">{{ 'common.atencion' | translate }}</h2>
            <p class="text-center app-text-gray font-14 line-height-3 mt-0 mb-5 ">{{dialogWarningMessage | translate }}</p>
          </div>
          <div class="flex justify-content-center align-items-center gap-2">
            <button class="border-round-3xl btn-shadow " pButton
                    [label]="'common.cerrar' | translate" (click)="onHide()">
            </button>
            <button class="border-round-3xl btn-shadow " pButton icon="pi pi-angle-right" [iconPos]="'right'"
                    [label]="'common.continuar' | translate" (click)="redirectFirma()">
            </button>
          </div>
        </section>
      </div>
    </main>
  </p-dialog>
  `
})
export class MensajeFirmaElectronicaInvalidaComponent {

  @Input() visible: boolean = false;

  constructor(private _ls: LocalService, private _router: Router) {

  }

  get dialogWarningMessage(): string {
    let msg = '';
    if (!this._ls.isFirmaElectronicaHabilitada) {
      msg = 'msg.firmaElectronicaNoActiva';
    } else if (this._ls.isFirmaElectronicaExpired) {
      msg = 'msg.firmaElectronicaVencida';
    } else if (this._ls.isFirmaElectronicaProximaVencimiento) {
      msg = 'msg.firmaElectronicaProximaVencimiento';
    }
    return msg;
  }

  redirectFirma() {
    if (!this._ls.isFirmaElectronicaHabilitada) {
      this._router.navigate(['/firma-electronica/solicitar']);
    } else if (this._ls.isFirmaElectronicaExpired) {
      this._router.navigate(['/firma-electronica/renovar']);
    } else if (this._ls.isFirmaElectronicaProximaVencimiento) {
      this._router.navigate(['/firma-electronica/renovar']);
    }
  }

  onHide() {
    this.visible = false;
  }
}
